import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { editorUrl, url } from 'utils/url';
import { errorMsg, log } from 'utils';
import fileDownload from 'js-file-download';
import moment from 'moment';

export const PRODUCT_FETCH_DATA_INIT = createAction('PRODUCT_FETCH_DATA_INIT');
export const PRODUCT_FETCH_DATA_SUCCESS = createAction(
  'PRODUCT_FETCH_DATA_SUCCESS'
);
export const PRODUCT_FETCH_DATA_FAIL = createAction('PRODUCT_FETCH_DATA_FAIL');

export const PRODUCT_FETCH_SHAPE_INIT = createAction(
  'PRODUCT_FETCH_SHAPE_INIT'
);
export const PRODUCT_FETCH_SHAPE_SUCCESS = createAction(
  'PRODUCT_FETCH_SHAPE_SUCCESS'
);
export const PRODUCT_FETCH_SHAPE_FAIL = createAction(
  'PRODUCT_FETCH_SHAPE_FAIL'
);

export const PRODUCT_DELETE_INIT = createAction('PRODUCT_DELETE_INIT');
export const PRODUCT_DELETE_SUCCESS = createAction('PRODUCT_DELETE_SUCCESS');
export const PRODUCT_DELETE_FAIL = createAction('PRODUCT_DELETE_FAIL');

export const PRODUCT_CLEAR_DATA = createAction('PRODUCT_CLEAR_DATA');

export const PRODUCT_CREATE_INIT = createAction('PRODUCT_CREATE_INIT');
export const PRODUCT_CREATE_SUCCESS = createAction('PRODUCT_CREATE_SUCCESS');
export const PRODUCT_CREATE_FAIL = createAction('PRODUCT_CREATE_FAIL');

export const PRODUCT_MODIFY_INIT = createAction('PRODUCT_MODIFY_INIT');
export const PRODUCT_MODIFY_SUCCESS = createAction('PRODUCT_MODIFY_SUCCESS');
export const PRODUCT_MODIFY_FAIL = createAction('PRODUCT_MODIFY_FAIL');

export const PRODUCT_CLEAN_UP = createAction('PRODUCT_CLEAN_UP');
export const PRODUCT_CLEAN_UP_FORM = createAction('PRODUCT_CLEAN_UP_FORM');

export const PRODUCT_CLEAR_DATA_LOGOUT = createAction(
  'PRODUCT_CLEAR_DATA_LOGOUT'
);
export const PRODUCT_EXPORT_INIT = createAction('PRODUCT_EXPORT_INIT');
export const PRODUCT_EXPORT_SUCCESS = createAction('PRODUCT_EXPORT_SUCCESS');
export const PRODUCT_EXPORT_FAIL = createAction('PRODUCT_EXPORT_FAIL');

export const PRODUCT_FETCH_RATINGS_INIT = createAction(
  'PRODUCT_FETCH_RATINGS_INIT'
);
export const PRODUCT_FETCH_RATINGS_SUCCESS = createAction(
  'PRODUCT_FETCH_RATINGS_SUCCESS'
);
export const PRODUCT_FETCH_RATINGS_FAIL = createAction(
  'PRODUCT_FETCH_RATINGS_FAIL'
);

export const PRODUCT_FETCH_RATING_INIT = createAction(
  'PRODUCT_FETCH_RATING_INIT'
);
export const PRODUCT_FETCH_RATING_SUCCESS = createAction(
  'PRODUCT_FETCH_RATING_SUCCESS'
);
export const PRODUCT_FETCH_RATING_FAIL = createAction(
  'PRODUCT_FETCH_RATING_FAIL'
);

export const fetchProducts = ({ siteId }) => {
  return async (dispatch, getState) => {
    dispatch(PRODUCT_FETCH_DATA_INIT());

    let productData;
    try {
      productData = await Axios.get(`${url}/product/list/${siteId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(PRODUCT_FETCH_DATA_FAIL({ error }));
    }
    const product = productData.data.data;

    return dispatch(
      PRODUCT_FETCH_DATA_SUCCESS({
        list: [product],
        product: getState().products.product,
      })
    );
  };
};

export const getProductsById = ({ siteId, productId }) => {
  return async (dispatch, getState) => {
    dispatch(PRODUCT_FETCH_DATA_INIT());

    let productData;
    try {
      productData = await Axios.get(
        `${url}/product/list/${siteId}/${productId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      toastr.error('', `${errorMsg(dispatch, error)}`);
      return dispatch(PRODUCT_FETCH_DATA_FAIL({ error }));
    }
    const product = productData.data.data[0];

    return dispatch(
      PRODUCT_FETCH_DATA_SUCCESS({
        list: getState().products.list,
        product: product,
      })
    );
  };
};

export const removeProduct = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(PRODUCT_DELETE_INIT());
    try {
      await Axios.post(
        `${url}/poi/remove`,
        {
          poiId: id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        PRODUCT_DELETE_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The poi was removed.');
    cb();
    return dispatch(PRODUCT_DELETE_SUCCESS({ id }));
  };
};

export const deletePoi = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(PRODUCT_DELETE_INIT());
    try {
      await Axios.post(
        `${url}/poi/delete`,
        {
          poiId: id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        PRODUCT_DELETE_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The poi was deleted.');
    cb();
    return dispatch(PRODUCT_DELETE_SUCCESS({ id }));
  };
};

export const clearPoisData = () => {
  return (dispatch) => {
    dispatch(PRODUCT_CLEAR_DATA());
  };
};

export const clearPoisDataLogout = () => {
  return (dispatch) => {
    dispatch(PRODUCT_CLEAR_DATA_LOGOUT());
  };
};

export const createProduct = (
  {
    name,
    description,
    file,
    firstFileList,
    secondFileList,
    categoryIds = [],
    subCategoryIds = [],
    tags = [],
    quantity,
    availability,
    siteId,
    start,
    end,
    userId,
  },
  cb
) => {
  return async (dispatch) => {
    dispatch(PRODUCT_CREATE_INIT());

    const formData = new FormData();

    formData.set('name', name);
    formData.set('description', description || '');
    formData.set('siteId', siteId);

    formData.set('quantity', quantity ?? 0);
    formData.set('availability', availability ?? true);
    formData.set('userId', userId);

    if (categoryIds.length > 0) {
      formData.set('categoryIds', JSON.stringify(categoryIds));
    }

    if (subCategoryIds.length > 0) {
      formData.set('subCategoryIds', JSON.stringify(subCategoryIds));
    }

    if (tags.length > 0) {
      formData.set('tags', JSON.stringify(tags));
    }

    if (start) {
      formData.set('start', moment(start).format('YYYY-MM-DD'));
    }

    if (end) {
      formData.set('end', moment(end).format('YYYY-MM-DD'));
    }

    if (file) {
      formData.append('file', file.originFileObj || file, `logo-${file.name}`);
    }

    if (firstFileList?.length) {
      for (let i = 0; i < firstFileList.length; i++) {
        const f = firstFileList[i];
        if (f) {
          formData.append(
            'file',
            f.originFileObj || f,
            `firstMedias-${f.name}`
          );
        }
      }
    }

    if (secondFileList?.length) {
      for (let i = 0; i < secondFileList.length; i++) {
        const f = secondFileList[i];
        if (f) {
          formData.append(
            'file',
            f.originFileObj || f,
            `secondMedias-${f.name}`
          );
        }
      }
    }

    try {
      const res = await Axios.post(`${url}/product/create`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      toastr.success('', 'Product created successfully');

      dispatch(
        PRODUCT_CREATE_SUCCESS({
          data: [res.data.data],
        })
      );
      cb && cb();
    } catch (error) {
      toastr.error('', 'Failed to create product');

      return dispatch(
        PRODUCT_CREATE_FAIL({
          error: error?.response?.data,
        })
      );
    }
  };
};

export const modifyProduct = (
  id,
  {
    name,
    description,
    file,
    firstFileList,
    secondFileList,
    categoryIds = [],
    subCategoryIds = [],
    tags = [],
    quantity,
    availability,
    siteId,
    start,
    end,
    userId,
    firstMedias = [],
    secondMedias = [],
    logo,
  },
  cb
) => {
  return async (dispatch) => {
    dispatch(PRODUCT_MODIFY_INIT());

    const formData = new FormData();

    formData.set('name', name);
    formData.set('description', description || '');
    formData.set('siteId', siteId);

    formData.set('quantity', quantity ?? 0);
    formData.set('availability', availability ?? true);
    formData.set('userId', userId);

    if (categoryIds.length > 0) {
      formData.set('categoryIds', JSON.stringify(categoryIds));
    }

    if (subCategoryIds.length > 0) {
      formData.set('subCategoryIds', JSON.stringify(subCategoryIds));
    }

    if (tags.length > 0) {
      formData.set('tags', JSON.stringify(tags));
    }

    if (start) {
      formData.set('start', moment(start).format('YYYY-MM-DD'));
    }

    if (end) {
      formData.set('end', moment(end).format('YYYY-MM-DD'));
    }

    if (file && (file.originFileObj || file instanceof File)) {
      formData.append('file', file.originFileObj || file, `logo-${file.name}`);
    } else if (logo) {
      formData.set('logo', logo);
    }

    const newFirst = [];
    const existingFirst = [];

    if (firstFileList?.length) {
      for (let i = 0; i < firstFileList.length; i++) {
        const f = firstFileList[i];

        if (f.originFileObj || f instanceof File) {
          // ✅ new
          formData.append(
            'file',
            f.originFileObj || f,
            `firstMedias-${f.name}`
          );
        } else if (f.name) {
          existingFirst.push(f.name);
        }
      }
    }

    const existingSecond = [];

    if (secondFileList?.length) {
      for (let i = 0; i < secondFileList.length; i++) {
        const f = secondFileList[i];

        if (f.originFileObj || f instanceof File) {
          formData.append(
            'file',
            f.originFileObj || f,
            `secondMedias-${f.name}`
          );
        } else if (f.name) {
          existingSecond.push(f.name);
        }
      }
    }

    formData.set('firstMedias', JSON.stringify(existingFirst));
    formData.set('secondMedias', JSON.stringify(existingSecond));

    try {
      const res = await Axios.put(`${url}/product/update/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      toastr.success('', 'Product updated successfully');
      dispatch(
        PRODUCT_MODIFY_SUCCESS({
          product: res.data.data,
          id,
        })
      );

      cb && cb();
    } catch (error) {
      toastr.error('', 'Failed to update product');

      return dispatch(
        PRODUCT_MODIFY_FAIL({
          error: error?.response?.data,
        })
      );
    }
  };
};

export const downloadProduct = ({ siteId, siteName }) => {
  return async (dispatch) => {
    dispatch(PRODUCT_EXPORT_INIT());
    Axios.get(`${url}/product/export`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      responseType: 'blob',
      params: {
        siteId,
      },
    })
      .then((res) => {
        fileDownload(
          res.data,
          `products_export_${siteName}_${moment(new Date()).format(
            'YYYY-MM-DD'
          )}.xlsx`
        );
        return dispatch(PRODUCT_EXPORT_SUCCESS());
      })
      .catch((error) => {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(PRODUCT_EXPORT_FAIL({ error }));
      });
  };
};

export const bulkRecovery = ({ status, ids, siteId }, cb) => {
  return async () => {
    try {
      await Axios.post(
        `${url}/poi/bulk-status-change `,
        {
          status,
          ids,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (e) {
      console.log(e, 'error');
      toastr.error('', 'Something went wrong');
    }
    cb();
  };
};

export const poisCleanUp = () => (dispatch) => dispatch(PRODUCT_CLEAN_UP());
export const poisCleanUpForm = () => (dispatch) =>
  dispatch(PRODUCT_CLEAN_UP_FORM());
